import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';
import { PedidoFilter } from '../../filter';
import { AliquotasDRP } from '../aliquotas/aliquotas';
import { PedidoDRPResumo } from '../resumo';

@Injectable({
    providedIn: 'root'
})
export class PedidoDRPHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/pedidodrp`;
    }

    /** Carrega as alíquotas para o DRP do pedido */
    loadAliquotas(idPessoa: number, idCondicaoPagamento: number): Observable<AliquotasDRP> {
        const params = new HttpParams()
                            .append('idPessoa', idPessoa ? idPessoa.toString() : null)
                            .append('idCondicaoPagamento', idCondicaoPagamento ? idCondicaoPagamento.toString() : null);


        return this.customHttp.get<AliquotasDRP>(`${this.pathApi}/0/aliquotas`, {params});
    }

    /** Carregar o resumo do DRP dos pedidos */
    loadResumoPedidos(filter: PedidoFilter): Observable<PedidoDRPResumo> {
        // Filter
        let params = new HttpParams();
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<PedidoDRPResumo>(`${this.pathApi}/0/resumo`, {params});
    }

    /** Carregar o resumo do DRP por itens */
    loadResumoItens(filter: PedidoFilter): Observable<PedidoDRPResumo> {
        // Filter
        let params = new HttpParams();
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<PedidoDRPResumo>(`${this.pathApi}/0/resumo/itens`, {params});
    }
}
